import Icon from 'veui/components/Icon'
import { IconTrendMonitor } from 'dls-icons-vue'

Icon.register('trend-monitor', IconTrendMonitor)
